<template>
  <div class="c-exporter">
    <n-loader :loading="$var('load')" />
    <div class="export-button" :class="{'resize': !!title}" @click="show = true">
      <div class="image-place">
        <img :src="imgImport">
      </div>
      <div v-if="title" class="title">
        {{ title }}
      </div>
    </div>
    <div v-if="show" class="export-window-shadow">
      <div class="export-window">
        <div class="text title">Экспорт</div>
        <div v-if="type !== 'sheet'" class="text">По нажатию на кнопку "экспортировать", файл будет доступен на странице экспортов</div>
        <div v-else class="text">Выберите то - что хотите эксопртировать, файл будет доступен на странице экспортов</div>
        <div v-if="type !== 'sheet'" class="buttons">
          <n-button class="tool-btn cancel" @click="close">
            Отмена
          </n-button>
          <n-button class="tool-btn" @click="makeExport()">
            Экспортировать
          </n-button>
        </div>
        <div v-else>
          <div class="buttons">
            <n-button class="tool-btn" @click="makeExport()">
              Табель времени
            </n-button>
            <n-button class="tool-btn" @click="makeExport('sheetErrors')">
              Табель ошибок
            </n-button>
            <n-button class="tool-btn" @click="makeExport('sheetWithLocationPoints')">
              Табель точек
            </n-button>
            <n-button v-if="user.company.bin === '051240005485'" class="tool-btn" @click="makeExport('timesheetReport')">
              Переработки
            </n-button>
          </div>
          <div class="buttons center">
            <n-button class="tool-btn cancel" @click="close">
              Отмена
            </n-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imgImport from '../../assets/new/import-icon.svg'

export default {
  name: 'CExporter',
  props: {
    type: {
      type: String,
      default: 'sheet',
    },
    title: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      required: true,
    },
    stats: {
      type: Object,
      required: false,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      imgImport,
      user: $app.auth.user(),
      show: false,
    }
  },
  methods: {
    makeExport(type = null) {
      if (type === null) type = this.type
      this.$var('load', true)
      $api.companies.export(this.user.companyId, {
        ...this.data,
        type: type,
        stats: this.stats,
      }).then(() => {
        this.$router.push({ name: 'exports', })
      }).finally(() => {
        this.$var('load', false)
      })
    },
    close() {
      this.show = false
      this.$emit('done')
    },
  },
}
</script>

<style lang="scss" scoped>
  .c-exporter {
    .export-button {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 48px;
      padding: 0 16px;
      border: 1px solid var(--primary);
      border-radius: 12px;
      margin-left: 16px;
      font-size: 16px;
      line-height: 16px;
      font-weight: 700;
      color: var(--primary);

      .image-place {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        rotate: 180deg;
      }
    }
    .tool-btn {
      color: #FFFFFF;
      background-color: var(--primary);
      border: 3px solid var(--primary);
      border-radius: 24px;
      &.cancel {
        color: #000000;
        background-color: #D4CFCF;
        border: 3px solid #D4CFCF;
      }
    }
    .close {
      display: flex;
      align-items: center;
      justify-content: right;
      .circle {
        cursor: pointer;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        border: 1px solid var(--primary);
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--primary);
      }
    }
    .export-window-shadow {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      background: rgba(0, 0, 0, 0.2);
      z-index: 100000;
      display: flex;
      align-items: center;
      justify-content: center;
      .export-window {
        padding: 15px;
        width: 715px;
        background-color: #FFFFFF;
        border-radius: 16px;
      }
      .buttons {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-top: 20px;
        &.center {
          justify-content: center;
        }
        :deep() {
          .n-button {
            border: none;
            border-radius: 12px;
            height: 48px;
            min-width: 160px;
            width: 50%;
            margin-right: 15px;
            background-color: var(--primary);
            color: #FFFFFF;
            &:last-child {
              margin-right: 0;
            }

            &.cancel {
              background-color: #ffffff;
              color: var(--primary);
              font-weight: 700;
              border: 1px solid var(--primary);
            }
          }
        }
      }
      .text {
        font-size: 14px;
        text-align: center;
        margin-bottom: 20px;
       &.title {
         font-size: 18px;
         font-weight: 700;
         color: var(--primary);
       }
      }
    }
  }
</style>
